import { FormProvider, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import IconLogoL2DConformite from "src/core/assets/images/icons/logo-l2d-c.svg?react";
import { FormSelect } from "src/core/components/custom-ui/form-select";
import { Button } from "src/core/components/ui/button";
import { DialogFooter } from "src/core/components/ui/dialog";
import { ISelectOption } from "src/core/constants/options";
import { ModulerRiskFormValues } from "src/core/forms/cartography/modulerRisk.schema";

type Props = {
  form: UseFormReturn<ModulerRiskFormValues>;
  onSubmit: (data: ModulerRiskFormValues) => void;
  isLoading: boolean;
  isReadOnly: boolean;
  forcedRiskReasonOptions: ISelectOption[];
  setOpen?: (open: boolean) => void;
  inModal?: boolean;
};

export const ModulerRiskForm = ({
  form,
  onSubmit,
  isLoading,
  isReadOnly,
  forcedRiskReasonOptions,
  setOpen,
  inModal = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-y-10">
      <div className="flex flex-row gap-x-5 items-center font-light text-blue-completed border border-border rounded-lg h-40 bg-gray-xxlight px-10">
        {t("form.modulerRisk.riskMismatch")}
        <IconLogoL2DConformite />
      </div>
      <div className="flex flex-col gap-y-10">
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FormSelect
              control={form.control}
              name="reason"
              required
              label={t("form.modulerRisk.reason")}
              options={forcedRiskReasonOptions}
              className="w-full"
              disabled={isReadOnly}
            />

            {!isReadOnly && (
              <DialogFooter>
                <Button type="submit" variant="default" className="ml-[20px]" loading={isLoading}>
                  {t("form.modulerRisk.submit")}
                </Button>
                {inModal && (
                  <Button
                    variant="link"
                    onClick={(event) => {
                      event.preventDefault();
                      setOpen?.(false);
                    }}
                  >
                    {t("global.form.cancel")}
                  </Button>
                )}
              </DialogFooter>
            )}
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
